import "./buttons.css";

const Button = ({ type, preferedStyle, title, action, disabled = false }) => {
  return (
    <div className="button-div">
      <button
        type={type || "button"}
        className={preferedStyle ? `button ${preferedStyle}` : "button default"}
        onClick={() => {
          if (type === "button") action();
        }}
        disabled={disabled}
      >
        {title}
      </button>
    </div>
  );
};

export default Button;
